import { useContext, useEffect, useState } from "react";
import { ChatbotTopCtrls } from "./ChatbotTopCtrls";
import { ChatbotDisclaimer } from "./ChatbotDisclaimer";
import { ChatbotQuestionForm } from "./ChatbotQuestionForm";
import { ChatbotNotifications } from "./ChatbotNotifications";
import { ChatbotStateContext } from "../utils/chatbotContext";
import { ChatCurrentMessagesArray } from "../models/chatbotModels";
import { ChatbotConversationList } from "./ChatbotConversationList";
import { ChatbotStreamingResponse } from "./ChatbotStreamingResponse";
import { ChatbotScrollingConversation } from "./ChatbotScrollingConversation";

type ChatbotMainContentProps = {
  isNavVisible: boolean;
  initials: string | undefined;
  setIsNavVisible: (arg: boolean) => void;
}

export const ChatbotMainContent = ({ isNavVisible, setIsNavVisible, initials }: ChatbotMainContentProps) => {

  const chatbotCurrentState = useContext(ChatbotStateContext);
  const [isStreaming, setIsStreaming] = useState<boolean>(false);
  const [conversationMssgs, setConversationMssgs] = useState<ChatCurrentMessagesArray>([]);

  useEffect(() => {
    setIsStreaming(chatbotCurrentState?.isStreaming ? chatbotCurrentState?.isStreaming : false);
  }, [chatbotCurrentState.isStreaming]);

  useEffect(() => {
    setConversationMssgs(chatbotCurrentState?.selectedConversationMssgs ? chatbotCurrentState?.selectedConversationMssgs : []);
  }, [chatbotCurrentState.selectedConversationMssgs]);

  return (
    <>
      <ChatbotTopCtrls
        isNavVisible={isNavVisible}
        setIsNavVisible={setIsNavVisible} />
      {
        chatbotCurrentState.selectedConversationId || isStreaming || chatbotCurrentState.isCreating || chatbotCurrentState.streamingResponse ? (
          <ChatbotScrollingConversation dependencies={[conversationMssgs, isStreaming]}>
            {conversationMssgs && (
              <ChatbotConversationList initials={initials} />
            )}

            {(isStreaming || chatbotCurrentState.streamingResponse) && (
              <div className="mt-4 ml-4">
                <ChatbotStreamingResponse initials={initials} />
              </div>
            )}

          </ChatbotScrollingConversation>
        ) : (
          <ChatbotNotifications />
        )
      }
      <div className="sticky bottom-0">
        <ChatbotQuestionForm />
        <ChatbotDisclaimer />
      </div>
    </>
  );
};